import React from 'react';
import { Badge, Banner, BlockStack, Button, ButtonGroup, Icon, Modal, Popover, Spinner, Text, TextField, Tooltip } from '@shopify/polaris';
import { ChevronDownIcon, QuestionCircleIcon, SearchIcon, MagicIcon } from '@shopify/polaris-icons';
import Language from '../../../../i18n/Language';
import { AiLanguageArr } from '../../../../utils/LanguageList';
import { numToUnit } from '../ContentAuditDetail/extraFunc';
import KeywordSuggestions from '../ContentAuditDetail/components/KeywordSuggestions';
const t = Language;

/**
 * 选择目标关键词弹窗（搜索设置弹窗）
 *
 * 从 ContentAuditDetail/index.jsx 抽离而来，作为纯展示组件复用。
 * 所有状态与回调均通过 props 注入，组件本身不持有业务状态。
 */
const SelectTargetKeyword = ({
    // 弹窗开关
    open = false,
    onClose = () => { },
    // 顶部提示区（父级传入的 JSX）
    chooseTipsCase = null,
    // 目标关键词输入
    titleValue = '',
    targetKeywordPreviewValue = '',
    isShowKeywordSugPop = false,
    onInputChange = () => { },
    onFocusSearch = () => { },
    patchSettingState = () => { },
    // AI 建议入口
    isShowSuggestion = false,
    recommendLoading = false,
    onGetAiSuggestion = () => { },
    // 关键词下拉建议
    keywordSearchLoading = false,
    keywordSugData = [],
    customeSetState = false,
    onSelectCustomValue = () => { },
    // 关键词建议模块（Ranking / Suggested）
    isGscConnected = false,
    rankingKeywordsList = [],
    rankingLoading = false,
    recommendKeywordsList = [],
    keywordTabSel = 'suggested',
    onGetSearchPerformance = () => { },
    // 提示 Banner
    isShowGscBanner = true,
    gscConnecting = false,
    onConnectGsc = () => { },
    isRepetitionKey = false,
    isShowRepetitionKeyBanner = true,
    isShowAccordTypeBanner = true,
    setIsShowGscTip = () => { },
    pagetype = 'product',
    judgeAccordType = () => true,
    getSourceTypeText = (type) => type || 'product',
    // 受众地区 / 语言配置
    isShowAudienceLocal = false,
    currents = {},
    patchCountryState = () => { },
    aiLang = 'en',
    aiLangLabel = '',
    nationState = false,
    languageState = false,
    togglePopSelect = () => { },
    countryValue = '',
    countryView = [],
    countryLens = 0,
    onSelectCountry = () => { },
    getMoreCountry = () => { },
    onSelectLanguage = () => { },
    // 底部操作
    researchLoading = false,
    settingChangeState = false,
    onStartResearch = () => { },
}) => {
    return <Modal
        open={open}
        title={t("Select Target Keyword")}
        onClose={() => onClose()}
    >
        <div className='search_settings_modal_container'>
            <div className='search_set_detail_container'>
                <BlockStack gap={400}>
                    {chooseTipsCase}
                    <div className='search_settings_input'>
                        <div className='flex_layout search_settings_input_item'>
                            <Text variant="bodyMd" as="p">{t("Target Keyword")}</Text>
                            <Tooltip content={t("The keyword used to fetch SERP results for content optimization analysis.")}>
                                <span className='question_mark'><Icon source={QuestionCircleIcon} tone="subdued" /></span>
                            </Tooltip>
                        </div>
                        <div className='search_settings_input_row'>
                            <div className='search_settings_input_field'>
                                <Popover
                                    active={isShowKeywordSugPop}
                                    activator={
                                        <div>
                                            <TextField
                                                id="targetKeywordPreviewValue"
                                                value={targetKeywordPreviewValue}
                                                onChange={onInputChange}
                                                onFocus={() => onFocusSearch()}
                                                autoComplete="off"
                                                placeholder={t("Enter a keyword you want to rank for...")}
                                            />
                                        </div>
                                    }
                                    preferredAlignment='left'
                                    autofocusTarget="none"
                                    onClose={() => patchSettingState({ isShowKeywordSugPop: false })}
                                    fullWidth
                                >
                                    <div className='ai_keyword_suggestions_list'>
                                        <BlockStack gap={200}>
                                            <div className='ai_blog_topic_data'>
                                                {
                                                    keywordSearchLoading ? null : (!keywordSearchLoading && keywordSugData.length > 0) && keywordSugData.map((item, index) => {
                                                        return index === 0 ? <div key={`${item.keyword}-${index}`} className='ai_blog_topic_title Every_Card_Desc'>
                                                            <p>{t("Keyword")}</p>
                                                            <p>{t("Competition")}</p>
                                                            <p>{t("Volume")}</p>
                                                        </div> : <div key={`${item.keyword}-${index}`} className='ai_blog_topic_item' onClick={(e) => {
                                                            e && e.stopPropagation();
                                                            onInputChange(item.keyword, "targetKeywordSelectValue");
                                                        }}>
                                                            <p>{item.keyword}</p>
                                                            <p>
                                                                {
                                                                    (item.competition && ["HIGH", "MEDIUM", "LOW"].includes(item.competition)) ? <Badge tone={item.competition === "HIGH" ? "warning" : item.competition === "MEDIUM" ? "attention" : "success"}>{t(`${item.competition === "HIGH" ? "High" : item.competition === "MEDIUM" ? "Medium" : "Low"}`)}</Badge> : '-'
                                                                }
                                                            </p>
                                                            <p>{item.volume ? numToUnit(item.volume) : '-'}</p>
                                                        </div>
                                                    })
                                                }
                                                {
                                                    keywordSearchLoading ? <div key={`top_tab_public`} className='ai_blog_topic_title Every_Card_Desc'>
                                                        <p>{t("Keyword")}</p>
                                                        <p>{t("Competition")}</p>
                                                        <p>{t("Volume")}</p>
                                                    </div> : keywordSugData.length <= 1 && <div className='empty_data'><Badge>{t("No data")}</Badge></div>
                                                }
                                            </div>
                                            {
                                                (customeSetState && targetKeywordPreviewValue) ? <div className='custom_edit_item' onClick={(e) => {
                                                    e && e.stopPropagation();
                                                    onSelectCustomValue("targetKeywordPreviewValue");
                                                    if (keywordSugData.length === 0) {
                                                        patchSettingState({ isShowKeywordSugPop: false });
                                                    }
                                                }}>
                                                    <p style={{ color: '#000' }}>{t("Add")}:&nbsp;&nbsp;<span style={{ color: '#303030' }}>"{targetKeywordPreviewValue}"</span></p>
                                                </div> : null
                                            }
                                        </BlockStack>
                                    </div>
                                </Popover>
                            </div>
                            {
                                (!isShowSuggestion || recommendLoading) && <div className='search_settings_suggestion_btn'>
                                    {
                                        recommendLoading ? <Button variant='tertiary' disabled={recommendLoading} onClick={() => onGetAiSuggestion(titleValue)}>
                                            <span><Spinner size="small" /></span>
                                            <span>{t("Generate")}…</span>
                                        </Button> : <Button variant='tertiary' icon={MagicIcon} onClick={() => onGetAiSuggestion(titleValue)}>
                                            <span>{t("Get Suggestions")}</span>
                                        </Button>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </BlockStack>
                {/* 建议区域 */}
                {/*
                    展示逻辑:
                    - 链接GSC且有排名数据 -> 展示 Ranking Keywords(可单独展示，无需点AI建议)
                    - 点击AI建议(isShowSuggestion) -> 展示 Suggested Keywords；若同时满足上一条则两个tab一同展示
                    - 未链接GSC -> 无 Ranking Keywords，点AI建议只展示 Suggested Keywords
                */}
                {
                    (() => {
                        const showRanking = isGscConnected && rankingKeywordsList.length > 0;
                        const showSuggested = isShowSuggestion;
                        if (!showRanking && !showSuggested) return null;
                        return (
                            <KeywordSuggestions
                                showRanking={showRanking}
                                showSuggested={showSuggested}
                                keywordTabSel={keywordTabSel}
                                onTabChange={(id) => {
                                    patchSettingState({ keywordTabSel: id });
                                    // 切到 Ranking Keywords 时，若还没有数据则按需拉取 GSC 搜索性能数据
                                    if (id === 'ranking' && !rankingLoading && rankingKeywordsList.length === 0) {
                                        onGetSearchPerformance();
                                    }
                                }}
                                selectedKeyword={targetKeywordPreviewValue}
                                onSelectKeyword={(keyword) => onInputChange(keyword, "targetKeywordSuggestionValue")}
                                suggestedList={recommendKeywordsList}
                                suggestedLoading={recommendLoading}
                                rankingList={rankingKeywordsList}
                                rankingLoading={rankingLoading}
                            />
                        );
                    })()
                }
            </div>
            {/* Tip */}
            {
                (!isGscConnected && !rankingLoading && isShowGscBanner) && <Banner
                    title={t("Link GSC to obtain page ranking keywords")}
                    action={{
                        content: t("To connect"),
                        onAction: () => {
                            onConnectGsc();
                        },
                        loading: gscConnecting,
                    }}
                    onDismiss={() => patchSettingState({ isShowGscBanner: false })}
                ></Banner>
            }
            {
                Boolean(isRepetitionKey && isShowRepetitionKeyBanner) && <Banner
                    title={<div className='s_tip_banner'>
                        <p>
                            {t("This keyword is already used by another page. Multiple pages targeting the same keyword may compete with each other in search results.")}&nbsp;
                            <span onClick={() => {
                                window.open(`${process.env.PUBLIC_HELP_CENTER_ADMIN}/content-optimization/guideline/g4/`, '_blank');
                            }}>{t("Learn more.")}</span>
                        </p>
                    </div>}
                    tone='warning'
                    onDismiss={() => patchSettingState({ isShowRepetitionKeyBanner: false })}
                ></Banner>
            }
            {
                Boolean(!(judgeAccordType()) && isShowAccordTypeBanner) && <Banner
                    title={<div className='s_tip_banner'>
                        <p>
                            {t("Google search results for this keyword rarely include {{v1}} pages, which may make this page difficult to rank. Consider choosing a different keyword.", getSourceTypeText(pagetype) || '-')}
                        </p>
                    </div>}
                    tone='warning'
                    onDismiss={() => patchSettingState({ isShowAccordTypeBanner: false })}
                ></Banner>
            }
        </div>
        <div className='search_set_detail_footer'>
            <div className='audience_local_config'>
                <Popover
                    active={isShowAudienceLocal}
                    activator={
                        <div className="config_setting_item" onClick={() => patchCountryState({ isShowAudienceLocal: !isShowAudienceLocal })}>
                            {
                                currents?.src ? <img className='config_setting_flag' src={currents.src} alt='' /> : null
                            }
                            <Text variant="bodyMd" as="p" fontWeight='medium'>{currents?.name} · {aiLangLabel || AiLanguageArr.find(i => i.value === aiLang)?.label || 'English'}</Text>
                            <Icon source={ChevronDownIcon} tone="base" />
                        </div>
                    }
                    preferredPosition="above"
                    preferredAlignment="left"
                    onClose={() => patchCountryState({ isShowAudienceLocal: false })}
                >
                    <div className="audience_local_box">
                        <Popover
                            active={nationState}
                            activator={
                                <div className="aud_select">
                                    <Text variant="bodyMd" as="p" tone="subdued" fontWeight="semibold">{t("Audience location")}</Text>
                                    <Button
                                        disclosure
                                        fullWidth
                                        textAlign='left'
                                        onClick={() => togglePopSelect('nationState')}
                                    >
                                        <p className='nation_set' title={currents?.abb}>
                                            <img src={currents?.src} alt='' />
                                            <span style={{ color: '#303030', fontWeight: 550 }}>{currents?.name}</span>
                                        </p>
                                    </Button>
                                </div>
                            }
                            autofocusTarget="first-node"
                            onClose={() => togglePopSelect('nationState')}
                            preferredAlignment="left"
                        >
                            <div className='country_box'>
                                <TextField
                                    id="countryValue"
                                    value={countryValue}
                                    onChange={onInputChange}
                                    autoComplete="off"
                                    placeholder={t("Search")}
                                    prefix={<Icon source={SearchIcon} />}
                                    clearButton
                                    onClearButtonClick={() => onInputChange("", "countryValue")}
                                />
                                <div className='countrys_all'>
                                    {
                                        (countryView && countryView.length > 0) ? (countryView.map(item => {
                                            return <p key={item.abb} title={item.abb} onClick={() => onSelectCountry(item)}>
                                                <img src={item.src} alt={item.abb} />
                                                <span>{item.name}</span>
                                            </p>
                                        })) : null
                                    }
                                    {
                                        countryLens > 20 && <Button variant='plain' onClick={getMoreCountry}>{t("View more")}</Button>
                                    }
                                </div>
                            </div>
                        </Popover>
                        <Popover
                            active={languageState}
                            activator={
                                <div className="aud_select">
                                    <Text variant="bodyMd" as="p" tone="subdued" fontWeight="semibold">{t("Content language")}</Text>
                                    <Button
                                        disclosure
                                        fullWidth
                                        textAlign='left'
                                        onClick={() => togglePopSelect('languageState')}
                                    >
                                        <p className='lang_set'>
                                            <span className="flex_layout">
                                                <svg width="14" height="14" viewBox="3 3 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM10 4.5C7.98377 4.5 6.22118 5.58524 5.26367 7.20312L7.2627 9.20215C7.73476 9.6743 8 10.3148 8 10.9824V11.5C8 11.7761 8.22386 12 8.5 12C9.60457 12 10.5 12.8954 10.5 14V15.4775C12.52 15.2955 14.2254 14.0213 15.0205 12.25H14C13.8011 12.25 13.6104 12.1709 13.4697 12.0303C13.3291 11.8896 13.25 11.6989 13.25 11.5V11C13.25 10.5858 12.9142 10.25 12.5 10.25H10C9.02787 10.25 8.25 9.45499 8.25 8.49414C8.25002 7.95427 8.4997 7.4392 8.93066 7.10645L9.39258 6.75C9.48896 6.6756 9.54587 6.56024 9.5459 6.43848V6.39746C9.54598 5.5133 10.1655 4.77417 10.9941 4.58984C10.6718 4.53102 10.3393 4.5 10 4.5ZM4.65137 8.71191C4.55227 9.12498 4.5 9.55654 4.5 10C4.5 12.6961 6.43989 14.9389 9 15.4092V14C8.99999 13.7239 8.77614 13.5 8.5 13.5C7.39543 13.5 6.5 12.6046 6.5 11.5V10.9824C6.5 10.7126 6.3929 10.4535 6.20215 10.2627L4.65137 8.71191ZM12.875 5.31055C12.5368 5.75696 12.0007 6.04492 11.3975 6.04492C11.2031 6.04506 11.046 6.20307 11.0459 6.39746V6.43848C11.0459 7.02486 10.7736 7.57809 10.3096 7.93652L9.84766 8.29395C9.78818 8.33986 9.75002 8.41439 9.75 8.49414C9.75 8.63787 9.86756 8.75 10 8.75H12.5C13.6581 8.75 14.612 9.62502 14.7363 10.75H15.4492C15.4827 10.5048 15.5 10.2544 15.5 10C15.5 8.01633 14.4497 6.27804 12.875 5.31055Z" fill="#4A4A4A" />
                                                </svg>
                                            </span>
                                            <span className="flex_layout" style={{ color: '#303030', fontWeight: 550 }}>{aiLangLabel || AiLanguageArr.find(i => i.value === aiLang)?.label || 'English'}</span>
                                        </p>
                                    </Button>
                                </div>
                            }
                            autofocusTarget="first-node"
                            onClose={() => togglePopSelect('languageState')}
                            preferredAlignment="center"
                        >
                            <div className='language_box'>
                                {
                                    AiLanguageArr.map(item => {
                                        return <p key={item.value} onClick={() => onSelectLanguage(item)}>{item.label}</p>
                                    })
                                }
                            </div>
                        </Popover>
                    </div>
                </Popover>
            </div>
            <ButtonGroup>
                <Button disabled={researchLoading} onClick={() => onClose()}>{t("Cancel")}</Button>
                <Button variant='primary' onClick={() => onStartResearch('modal')} disabled={!targetKeywordPreviewValue || !settingChangeState} loading={researchLoading}>{t("Start Research")}</Button>
            </ButtonGroup>
        </div>
    </Modal>;
};

export default SelectTargetKeyword;
